import React from "react";

export default ({ data }) => (
  <div className="card w-full m-1 py-4 pl-3 pr-16 flex flex-row">
    <svg
      className={`scale-1 fill-current w-8 h-8 m-2 mr-6 ${data.type}`}
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
    >
      <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
    </svg>
    <div className="flex flex-col">
      <h3 className="text-sm text-left">{data.text}</h3>
      <p className="text-lg text-left">{data.value}</p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/analysis/card.js